import { gql } from '@apollo/client';
const COURSE_LIST_QUERY = gql`
query courses($useSegmentationFilter: Boolean, $limit:Int, $page: Int, $orderBy: String, $orderDir: String, $withCompleted: Boolean
$maxWidth: Int, $maxHeight: Int ) {
    courses(useSegmentationFilter: $useSegmentationFilter, limit: $limit, page: $page, orderBy: $orderBy, orderDir: $orderDir, withCompleted: $withCompleted) {
        pageInfo {
          page
          pageCount
          limit
          totalCount
        }
        edges {
                enrollment {
                    status
                    rating
                    review
                }          
                node {
                    tags
                    metadata
                    id
                    locales {
                        locale
                        name
                        description
                    }
                    thumbnailImage( params: {  maxHeight: $maxHeight, maxWidth: $maxWidth, mask: "image resizing" } ) {
                        id
                        url
                    }
                    learningObjects {
                        totalCount
                        edges {
                            assignment {
                                status
                            }
                            node {
                                id
                                content {
                                    id
                                    mimetype
                                    url
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
export default COURSE_LIST_QUERY;
//# sourceMappingURL=COURSE_LIST_QUERY.js.map